import { FC } from 'react';
import { observer } from 'mobx-react';
import PromotionSection from '../../components/Tabs/Promotion';
import propertyStore from 'stores/property';
import AppLayout from '../../Layout';


const Promotions: FC = observer(() => {
  const property = propertyStore.selected;

  return (
    <AppLayout>
      <div className="tab">
        <PromotionSection property={property} />
      </div>
    </AppLayout>
  )
});

export default Promotions;
